/* eslint-disable react/no-array-index-key */
import React from 'react'

import { Content } from '../../components/Typography'
import useMediaQuery from '../../hooks/useMediaQuery'
import { SectionContainer } from '../../layouts'
import { ContentParser } from '../../utils/helpers'
import {
  bgClassName,
  hero5050Container,
  hero5050ContentSection,
  hero5050ContentStyling,
  hero5050promoContainer,
  heroContentHeading,
  heroHeadingStyling,
  heroUspContainer,
  heroUspContent,
  heroUspIndicator,
  herSlideContent,
} from './Hero5050.module.css'

const Hero5050 = ({ slice }) => {
  const { slidecontenthalf, slideheadinghalf, slideimagehalf } = slice
  const isDesktop = useMediaQuery('(min-width: 768px)')
  let backGroundImage = slideimagehalf
  const steps = ContentParser(slice, 'halfstep')
  if (!isDesktop && slideimagehalf) {
    backGroundImage = slideimagehalf
  }
  return (
    <SectionContainer
      backGround={backGroundImage}
      backgroundClassName={bgClassName}
      extraClassName={hero5050Container}
    >
      <div className={hero5050ContentSection}>
        <div className={`${hero5050promoContainer}`}>
          <div className={heroContentHeading}>
            <Content
              extraClassName={heroHeadingStyling}
              renderContent={slideheadinghalf}
            />
            <Content
              extraClassName={hero5050ContentStyling}
              renderContent={slidecontenthalf}
            />
          </div>
          <div className={herSlideContent}>
            {steps.length > 0 &&
              steps.map((step, index) => {
                const { promocontent, promotext } = step
                return (
                  <div key={index} className={heroUspContainer}>
                    <span className={heroUspIndicator}>{index + 1}</span>
                    <p>{promotext}</p>
                    <p className={heroUspContent}>{promocontent}</p>
                  </div>
                )
              })}
          </div>
        </div>
      </div>
    </SectionContainer>
  )
}

export default Hero5050
